define(["marionette", "backbone", "messaging/messenger", "./reviewTypeToggleView"], function (
  Marionette,
  Backbone,
  Messenger,
  ReviewTypeToggleView,
) {
  "use strict";

  const ASSIGNED_TASKS = "assignedTasks";
  const MY_TASKS = "myTasks";
  const OTHER_TASKS = "otherTasks";

  let ReviewTypeToggleController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reviewTypeToggle";
      this.region = options.region;
      this.activeView = MY_TASKS;
    },
    show: function () {
      let canEditAnyTask = Messenger.reqres.request("can:edit:any:task");
      let model = new Backbone.Model({
        canEditAnyTask: canEditAnyTask,
      });
      this.view = new ReviewTypeToggleView.view({ model: model });
      this.view.on(
        "show:reviewType:assignedTasks",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              this.activeView = ASSIGNED_TASKS;
              Messenger.vent.trigger("show:reviewType:assignedTasks");
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:reviewType:myTasks",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              this.activeView = MY_TASKS;
              Messenger.vent.trigger("show:reviewType:myTasks");
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:reviewType:otherTasks",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              this.activeView = OTHER_TASKS;
              Messenger.vent.trigger("show:reviewType:otherTasks");
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show",
        function () {
          if (this.activeView === ASSIGNED_TASKS) {
            this.view.selectAssignedTasks();
          } else if (this.activeView === MY_TASKS) {
            this.view.selectMyTasks();
          } else {
            this.view.selectOtherTasks();
          }
        },
        this,
      );

      this.showRegion(this.view);
    },
    getActiveView: function () {
      return this.activeView;
    },
  });
  ReviewTypeToggleController.ASSIGNED_TASKS = ASSIGNED_TASKS;
  ReviewTypeToggleController.MY_TASKS = MY_TASKS;
  ReviewTypeToggleController.OTHER_TASKS = OTHER_TASKS;

  return ReviewTypeToggleController;
});
